import {ensureSessionOrRedirect, logoutSession} from 'helpers/session';

export default function authFetch(route, request, token) {
  if (!ensureSessionOrRedirect()) {
    return Promise.reject(new Error('Session expired'));
  }
  const authRequest = {
    ...request,
    headers: {
      ...request.headers,
      Authorization: `Bearer ${token}`,
    },
  };

  return fetch(route, authRequest).then((response) => {
    if (response.status === 401) {
      logoutSession('unauthorized', true);
      throw Object.assign(new Error('Authentication error'), {code: 401});
    }
    return response;
  });
}
